<template>
  <pt-taxation-table class="pt-taxation-table__withData" @getTableData="getTableData" :table-labels="tableLabels" :totalNumber="totalNumber" :pageSize="pageSize" :currentPage="currentPage"
   :tableData="tableData" ref="table" v-loading="loading">
  <slot/>
  </pt-taxation-table>
</template>

<script>
import PtTaxationTable from './index'
export default {
  name: 'pt-taxation-table__withData',
  components: {
    'pt-taxation-table': PtTaxationTable
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 0
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      loading: false
    }
  },
  methods: {
    getTableData (page, next) {
      let data = {
        page: this.page,
        size: this.pageSize
      }
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('getTaxProjctList', data).then(res => {
        this.totalNumber = res.totalNumber
        this.tableData = res.data
        if (next) {
          next(res.data)
        }
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取税务项目失败')
      })
    }
  }
}
</script>
